import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EntityService } from '../../services/entity.service';
import { NotificationService } from '../../services/notification.service';
import { getCurrentUserId } from '../../helpers/utils';
  import { Router } from '@angular/router';

@Component({
  selector: 'app-preferences',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.scss']
})
export class PreferencesComponent implements OnInit {
  categories: any[] = [];
  domains: any[] = [];
  loading: boolean = false;
  saving: boolean = false;
  error: string = '';
  selectedCount: number = 0;
  maxSelections: number = 5;

  // Mapping des icônes par slug
  private iconMapping: { [key: string]: string } = {
    'musique': 'fas fa-music',
    'sport': 'fas fa-futbol',
    'cinema-television': 'fas fa-film',
    'comedie': 'fas fa-theater-masks',
    'litterature': 'fas fa-book',
    'peinture-sculpture': 'fas fa-palette',
    'mode': 'fas fa-tshirt',
    'journalisme': 'fas fa-newspaper',
    'chroniqueurs': 'fas fa-microphone-alt',
    'youtubeurs-tiktokeurs-blogueurs': 'fab fa-youtube',
    'radio-podcasts': 'fas fa-broadcast-tower',
    'science': 'fas fa-flask',
    'technologie': 'fas fa-microchip',
    'politique': 'fas fa-landmark',
    'droits': 'fas fa-gavel',
    'business': 'fas fa-briefcase',
    'economie': 'fas fa-chart-line',
    'cuisine': 'fas fa-utensils'
  };

  // Mapping des descriptions par slug
  private descriptionMapping: { [key: string]: string } = {
    'musique': 'Artistes, musiciens et professionnels de la musique',
    'sport': 'Athlètes, entraîneurs et personnalités du sport',
    'cinema-television': 'Acteurs, réalisateurs et personnalités TV',
    'comedie': 'Humoristes et comédiens',
    'litterature': 'Écrivains et auteurs',
    'peinture-sculpture': 'Artistes visuels et plasticiens',
    'mode': 'Créateurs, mannequins et influenceurs mode',
    'journalisme': 'Journalistes et reporters',
    'chroniqueurs': 'Chroniqueurs et commentateurs',
    'youtubeurs-tiktokeurs-blogueurs': 'YouTubeurs, TikTokeurs et blogueurs',
    'radio-podcasts': 'Animateurs radio et podcasteurs',
    'science': 'Scientifiques et chercheurs',
    'technologie': 'Experts et innovateurs tech',
    'politique': 'Personnalités politiques',
    'droits': 'Avocats et juristes',
    'business': 'Entrepreneurs et leaders d\'entreprise',
    'economie': 'Économistes et analystes financiers',
    'cuisine': 'Chefs et experts culinaires'
  };

  constructor(
    private entityService: EntityService,
    private notificationService: NotificationService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadCategories();
  }

  private loadCategories() {
    this.loading = true;
    this.entityService.getDatas<any>('/domains').subscribe({
      next: (domains) => {
        this.domains = domains;
        this.categories = domains.flatMap(domain => domain.categories || []);
        this.loading = false;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des catégories:', error);
        this.error = 'Erreur lors du chargement des catégories';
        this.loading = false;
        this.notificationService.error('Erreur lors du chargement des catégories');
      }
    });
  }

  toggleCategory(category: any) {
    if (!category.selected && this.selectedCount >= this.maxSelections) {
      this.notificationService.create(
        `Vous ne pouvez sélectionner que ${this.maxSelections} centres d'intérêt maximum`, 
        'warning'
      );
      return;
    }
    
    category.selected = !category.selected;
    this.selectedCount = this.categories.filter(c => c.selected).length;
  }

  savePreferences() {
    if (this.selectedCount === 0) {
      this.notificationService.create('Veuillez sélectionner au moins un centre d\'intérêt', 'warning');
      return;
    }

    this.saving = true;
    const userId = getCurrentUserId();
    
    if (!userId) {
      this.notificationService.error('Utilisateur non connecté');
      this.saving = false;
      return;
    }

    const selectedCategories = this.categories
      .filter(cat => cat.selected)
      .map(cat => cat.id);

    const payload = {
      user_id: userId,
      domains: selectedCategories
    };

    this.entityService.justSave('/interests/save', payload).subscribe({
      next: (response) => {
        this.notificationService.success('Préférences enregistrées avec succès');
        this.saving = false;
        this.router.navigate(['/']);
      },
      error: (error) => {
        console.error('Erreur lors de la sauvegarde des préférences:', error);
        this.notificationService.error('Erreur lors de la sauvegarde des préférences');
        this.saving = false;
      }
    });
  }
} 